export enum UpgradeAccountsCompleteStage {
  UpgradeAccountsCompleteStartStage = 'UpgradeAccountsCompleteStartStage',
  UpgradeAccountsCompleteBuildBusinessStage = 'UpgradeAccountsCompleteBuildBusinessStage',
  UpgradeAccountsXeroIntegrationStage = 'UpgradeAccountsXeroIntegrationStage',
  UpgradeAccountsDebitCardsRewardsStage = 'UpgradeAccountsDebitCardsRewardsStage',
  UpgradeAccountsReadyToGoStage = 'UpgradeAccountsReadyToGoStage',
}

export type UpgradeAccountsCompleteStateConfigType = {
  pathname?: string
}

export interface UpgradeAccountsCompleteState {
  stage: UpgradeAccountsCompleteStage
}
